import globalScope from 'core/globalScope';
import $ from 'jquery';
import Cookies from 'js-cookie';
import { throttle } from 'throttle-debounce';
import ga from 'ga';
import tag_commander from 'tracking/tag_commander';
import { modifiePubNative } from 'pubs/appnexus_init';
import { offreSponsoId } from 'modules/offre_sponso';
import pieCompletion from 'modules/pie-completion';
import 'jquery-ui/ui/widgets/slider';
import 'modules/jquery.multiSelector';
import 'modules/jquery.dualLevelSelector';
import 'modules/jquery.localisationSelector';
import 'modules/jquery.elargirRechercheSelector';
import ToasterCreationAlerte from 'modules/toaster_creation_alerte';

const document = globalScope.document;
const window = globalScope.window;

function moteur_top(configuration) {
  const PAGE_HOME = 'home';
  const PAGE_LISTE_OFFRE = 'liste-offre';

  const SUGGESTION_VILLE = 'ville';
  const SUGGESTION_DEPARTEMENT = 'departement';
  const SUGGESTION_REGION = 'region';
  const DISTANCES_KILOMETRIQUES = [0, 10, 20, 50, 100];

  const motCle = $('.js-mot-cle');
  const motsClesTop = $('.js-motsCles-top');
  const salaireMinMobile = $('.js-salaire-min-mobile');
  const recherchesMemorisees = $('.js-recherches-memorisees');
  const suggestionsAutocompleteContainer = $('.js-suggestions-autocomplete-container');
  const localisationTrigger = $('.js-localisation-trigger');
  const localisationOptions = $('.js-localisation-options');
  const salaireMinValue = $('.js-salaire-min-value');
  const rappelCriteresScrollActivation = $('.js-rappel-criteres-scroll-activation');
  const moteurLoaderSearch = $('.js-moteur-loader-search');
  const listeCriteres = $('.js-liste-criteres');
  const moteurTopListe = $('.js-moteur-top-liste');
  const elargirRechercheContainer = $('.js-elargir-recherche-container');
  const elargirRechercheSelector = $('.js-elargir-recherche-selector');
  const rappelCriteresMotsCles = $('.js-rappel-criteres-mots-cles');
  const effacerCriteres = $('.js-effacer-criteres');
  const monochampsRecherche = $('#js-mobile-monochamps-recherche');

  let model = {};
  if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
    model = {
      motsCles: motsClesTop.val() || configuration.selectedMotsCles,
      fonctions: configuration.selectedFonctions,
      secteurs: configuration.selectedSecteurs,
      localisation: configuration.selectedLocalisation,
      regions: configuration.selectedRegions,
      departements: configuration.selectedDepartements,
      contrats: configuration.selectedContrats,
      salaireMin: configuration.selectedSalaireMin,
      page: configuration.pageCourante,
      tri: configuration.tri
    };
  }

  if (configuration.moteurRechercheConfiguration.page === PAGE_HOME) {
    model = {
      motsCles: '',
      localisation: null,
      regions: [],
      departements: [],
      fonctions: [],
      secteurs: [],
      contrats: [],
      salaireMin: 0
    };
  }

  let useAjax = configuration.doitUtiliserPaginationAjax || false;
  let hasLoaded = false;
  let hasCriteres = false;
  let urlCleared = false;
  let trackingPausedForCriteriaRemoval = false;

  initialiseSelectors();

  //LISTE
  if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
    motsClesTop.val(model.motsCles);
  }

  setNotEmptyClass(motsClesTop);
  let timeout = null;
  motsClesTop.on('change keyup paste', function(e) {
    rappelCriteresMotsCles.addClass('hidden');
    const motsCles = $(this);
    const motsClesVal = motsCles.val();

    if (e.key === 'Enter') {
      suggestionsAutocompleteContainer.empty();
      suggestionsAutocompleteContainer.removeClass('toggled');
      model.motsCles = motsClesVal;
      $('.js-moteur-top-submit').click();
      return;
    }

    if (motsClesVal === '') {
      suggestionsAutocompleteContainer.empty();
      suggestionsAutocompleteContainer.removeClass('toggled');
      recherchesMemorisees.addClass('visible');
      model.motsCles = '';
    } else {
      recherchesMemorisees.removeClass('visible');
      if (model.motsCles !== motsClesVal) {
        setNotEmptyClass(motsCles);
        window.clearTimeout(timeout);

        // Attends la fin de l'input par l'utilisateur avant de recharger la liste
        timeout = window.setTimeout(function() {
          $.ajax({
            type: 'GET',
            dataType: 'html',
            url: `/emploi/composants/suggestions-keywords/${encodeURIComponent(motsClesVal)}`
          }).done(function(data) {
            suggestionsAutocompleteContainer.empty();
            suggestionsAutocompleteContainer.append(data);
            suggestionsAutocompleteContainer.addClass('toggled');
          });
        }, 200);

        model.motsCles = motsClesVal;
      }
    }

    modelUpdated();
  });

  $(suggestionsAutocompleteContainer).on('click', '.js-sub-suggestion-autocomplete', function() {
    let elementId = $(this).attr('id');
    let elementText = $(this)
      .text()
      .trim();
    let motsCles = monochampsRecherche;
    if (elementId.startsWith('SECTEUR')) {
      model.secteurs = merge(
        model.secteurs,
        JSON.parse(
          $(this)
            .find('span')
            .text()
        )
      );
      motsCles.val('');
      model.motsCles = '';
      loadSecteurs();
      ga.sendEvent('temporaire', 'change_recherche', 'change_secteurviaautocomplete');
    } else if (elementId.startsWith('FONCTION')) {
      model.fonctions = merge(
        model.fonctions,
        JSON.parse(
          $(this)
            .find('span')
            .text()
        )
      );
      motsCles.val('');
      model.motsCles = '';
      loadFonctions();
      ga.sendEvent('temporaire', 'change_recherche', 'change_fonctionviaautocomplete');
    } else if (elementId.startsWith('MOTCLE')) {
      model.motsCles = elementText;
      motsCles.val(elementText);
      ga.sendEvent('temporaire', 'change_recherche', 'change_motcleviaautocomplete');
    }
    suggestionsAutocompleteContainer.empty();
    suggestionsAutocompleteContainer.removeClass('toggled');

    modelUpdated();
    load();
  });

  function merge(modelArray, toAddArray) {
    const result = [];
    const map = new Map();
    if (modelArray !== 'undefined') {
      modelArray.push(...toAddArray);
      modelArray.forEach(function(item) {
        if (!map.has(item.code)) {
          map.set(item.code, true); // peu importe la valeur
          result.push(item);
        }
      });
    } else {
      result.push(...toAddArray);
    }
    return result;
  }

  $('.js-suggest-motsCles-highlighted').on('click', function() {
    const suggestedKeywords = $(this);

    if (model.motsCles !== suggestedKeywords.children().text()) {
      model.motsCles = suggestedKeywords.children().text();
      setNotEmptyClass(motsClesTop);
      modelUpdated();
      load();
    }
  });

  loadFonctions();
  loadSecteurs();

  function loadFonctions() {
    $('.js-fonctions-moteur-liste').dualLevelSelector({
      onItemsSelected: function(selectedItems) {
        model.fonctions = selectedItems;
        modelUpdated();

        if (!trackingPausedForCriteriaRemoval) {
          ga.deprecatedSendEvent('temporaire', 'change_recherche', 'change_fonctions');
        }

        load();
      },
      availableItems: configuration.moteurRechercheConfiguration.fonctionsPourRecherche,
      selectedItems: model.fonctions
    });
  }

  function loadSecteurs() {
    $('.js-secteurs-moteur-liste').dualLevelSelector({
      onItemsSelected: function(selectedItems) {
        model.secteurs = selectedItems;
        modelUpdated();

        if (!trackingPausedForCriteriaRemoval) {
          ga.deprecatedSendEvent('temporaire', 'change_recherche', 'change_secteurs');
        }

        load();
      },
      availableItems: configuration.moteurRechercheConfiguration.secteursPourRecherche,
      selectedItems: model.secteurs
    });
  }

  $('.js-contrats-moteur-liste').multiSelector({
    onItemsSelected: function(selectedItems) {
      model.contrats = selectedItems;
      modelUpdated();

      if (!trackingPausedForCriteriaRemoval)
        ga.deprecatedSendEvent('temporaire', 'change_recherche', 'change_contrats');

      load();
    },
    availableItems: configuration.moteurRechercheConfiguration.contratsPourRecherche,
    selectedItems: model.contrats
  });

  salaireMinValue.html(
    model.salaireMin === 0 ? 'Indiff&eacute;rent' : Math.round(model.salaireMin / 1000) + 'K&euro;'
  );
  if (model.salaireMin !== 0) {
    salaireMinMobile.val(Math.round(model.salaireMin / 1000));
  }

  $('.js-slider-salaire-min').slider({
    range: 'max',
    min: 0,
    max: 200000,
    value: model.salaireMin,
    step: 10000,
    slide: function(event, ui) {
      salaireMinValue.html(
        ui.value === 0 ? 'Indiff&eacute;rent' : Math.round(ui.value / 1000) + 'K&euro;'
      );
    },
    change: function(event, ui) {
      model.salaireMin = ui.value;
      modelUpdated();
      if (!trackingPausedForCriteriaRemoval) {
        ga.deprecatedSendEvent('temporaire', 'change_recherche', 'change_salaire');
      }
      load();
    }
  });

  salaireMinMobile.change(function() {
    model.salaireMin = $(this).val() * 1000;
    modelUpdated();
    ga.deprecatedSendEvent('temporaire', 'change_recherche', 'change_salaire');
    load();
  });

  motCle.focusin(function() {
    //LISTE
    if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
      openModal();
    }
    recherchesMemorisees.addClass('visible');
    rappelCriteresMotsCles.addClass('hidden');
  });

  motCle.focusout(function() {
    recherchesMemorisees.removeClass('visible');
    toggleRappelCriteresMotsCles();
  });

  rappelCriteresMotsCles.click(function() {
    rappelCriteresMotsCles.addClass('hidden');
    monochampsRecherche.focus();
  });

  effacerCriteres.click(function() {
    ga.deprecatedSendEvent('temporaire', 'change_recherche', 'effacer_filtres');
    trackingPausedForCriteriaRemoval = true;

    $('.js-motsCles-top, .js-localisation-trigger, .js-tri').val('');
    elargirRechercheContainer.hide();

    $('.js-slider-salaire-min').slider('value', 0);
    listeCriteres.find('.multi-checkbox').prop('checked', false);
    listeCriteres.find('.multi-checkbox').trigger('uncheckAll');

    // Nettoyage des crit�res
    model.motsCles = '';
    model.localisation = null;
    model.regions = [];
    model.departements = [];
    model.fonctions = [];
    model.secteurs = [];
    model.contrats = [];
    model.salaireMin = 0;
    model.page = 1;
    model.tri = null;

    modelUpdated();
    load();

    trackingPausedForCriteriaRemoval = false;
  });

  $('.js-filtrer-criteres, .js-rappel-criteres-scroll, .js-rappel-criteres-mots-cles').click(() =>
    openModal()
  );

  $('.js-close-modal').click(() => closeModal());

  //HOME
  if (configuration.moteurRechercheConfiguration.page === PAGE_HOME) {
    $('.js-filtrer-criteres').hide();
    $('.js-moteur-top-submit').click(function() {
      const parameters = Object.assign(buildParameters(model), {
        rubrique: 'home' // utilis� pour prendre le MoteurRecherche.HOME cote serveur et mettre la bonne provenance dans les variables TagCo
      });
      const trackingCriteres = buildTrackingCriteres(model);
      let trackingLibelle = '';
      if (trackingCriteres.length > 0) {
        trackingLibelle += '_' + trackingCriteres.join('-');
      }
      ga.sendEvent('temporaire', 'abtest_moteur_hp', 'recherche_' + trackingLibelle);

      post('/emploi/liste_offres/rechercher', parameters);
    });
  }

  //HOME
  function post(path, parameters) {
    const form = $('<form></form>');

    form.attr('method', 'post');
    form.attr('action', path);
    form.attr('accept-charset', 'ISO-8859-1');

    $.each(parameters, function(key, value) {
      if (typeof value === 'object' || Array.isArray(value)) {
        $.each(value, function(subkey, subvalue) {
          const field = $('<input />');
          field.attr('type', 'hidden');
          field.attr('name', key);
          field.attr('value', subvalue);
          form.append(field);
        });
      } else {
        const field = $('<input />');
        field.attr('type', 'hidden');
        field.attr('name', key);
        field.attr('value', value);
        form.append(field);
      }
    });
    $(document.body).append(form);
    form.submit();
  }

  function load() {
    if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) loadListeOffre();
  }

  function modelUpdated() {
    const fonctionsTab = $('.js-fonctions-tab');
    const contratsTab = $('.js-contrats-tab');
    const salaireMinTab = $('.js-salaire-min-tab');
    const secteursTab = $('.js-secteurs-tab');

    const filtreFonctionsActif = model.fonctions.length !== 0;
    const filtreContratsActif = model.contrats.length !== 0;
    const filtreSalaireMinActif = model.salaireMin !== 0;
    const filtreSecteursActif = model.secteurs.length !== 0;

    const filtreLocalisationActif = !!model.localisation;
    const filtreMotsCLes = !!model.motsCles;

    filtreFonctionsActif ? fonctionsTab.addClass('actif') : fonctionsTab.removeClass('actif');
    filtreContratsActif ? contratsTab.addClass('actif') : contratsTab.removeClass('actif');
    filtreSalaireMinActif ? salaireMinTab.addClass('actif') : salaireMinTab.removeClass('actif');
    filtreSecteursActif ? secteursTab.addClass('actif') : secteursTab.removeClass('actif');

    updateCritereLabel(fonctionsTab, model.fonctions);
    updateCritereLabel(contratsTab, model.contrats);
    updateCritereLabel(secteursTab, model.secteurs);

    // Afficher boutons activation alerte et effacer crit�res
    if (
      filtreFonctionsActif ||
      filtreContratsActif ||
      filtreSalaireMinActif ||
      filtreSecteursActif ||
      filtreLocalisationActif ||
      filtreMotsCLes
    ) {
      hasCriteres = true;

      //LISTE
      if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
        $('.js-creer-alerte').removeClass('hidden');
        effacerCriteres.removeClass('hidden');
      }

      if (!$('.js-suggestion-autocomplete')) {
        rappelCriteresMotsCles.removeClass('hidden');
      }
      $('.filtrer-criteres').addClass('actif');
    } else {
      hasCriteres = false;

      //LISTE
      if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
        $('.js-creer-alerte').addClass('hidden');
        effacerCriteres.addClass('hidden');
      }

      rappelCriteresMotsCles.addClass('hidden');
      $('.filtrer-criteres').removeClass('actif');
    }

    updateRappelCriteres();
    toggleRappelCriteresMotsCles();
    if (hasLoaded) {
      model.page = 1;
      useAjax = true;
    }
    hasLoaded = true;
  }

  function updateCritereLabel(critereTab, criteres) {
    const nbDeCriteres = computeNbDeCriteres(criteres);
    const critere = critereTab.find('.js-open-critere');
    const label = critere.text().split(' ')[0];
    if (nbDeCriteres > 0) {
      critere.html(label + ' &bull; ' + nbDeCriteres);
    } else {
      critere.html(label);
    }
  }

  function computeNbDeCriteres(criteres) {
    return criteres.reduce(
      // On ne compte pas les niveaux 1 avec sub levels
      (sum, critere) => (critere.subLevels && critere.subLevels.length > 0 ? sum : sum + 1),
      0
    );
  }

  function seoUpdated() {
    if (hasCriteres) {
      $('.js-liste-offres-colonne-seo').replaceWith();
      $('.js-footer-seo').replaceWith();
    }
  }

  function removeUrlParams() {
    if (!urlCleared) {
      window.history.replaceState(null, '', 'liste_offres');
    }

    urlCleared = true;
  }

  let loadTimeoutListe = null;
  let loadTimeOutLocalisationSelector = null;

  function loadListeOffre() {
    moteurLoaderSearch.show(0);
    window.clearTimeout(loadTimeoutListe);

    // Attends la fin de l'input par l'utilisateur avant de recharger la liste
    loadTimeoutListe = window.setTimeout(function() {
      $.ajax({
        type: 'POST',
        url: '/emploi/liste_offres/recherche/ajax',
        contentType: 'application/json',
        data: JSON.stringify(model),
        success: function(data) {
          const $blocAnnonce = $('.js-bloc-annonce');
          const $moteurLoaderSearch = moteurLoaderSearch;

          $blocAnnonce.css('opacity', '0.1');
          $moteurLoaderSearch.css('opacity', '1');
          $blocAnnonce.html(data.html);

          seoUpdated();
          removeUrlParams();

          trackApplyButtonsDisplay(configuration.isUserConnected);
          tag_commander.trackerPageViewAsync(data.dataContainer, configuration.ceVersion);

          // Retourner en haut de la page
          if (window.scrollY > 700) {
            $('html, body').animate({ scrollTop: 0 }, 'fast');
          }
          $moteurLoaderSearch.hide(0);
          $blocAnnonce.fadeTo(800, 1);

          // copie du contenu du widget de completion de profil
          $('#js-completion-profil-placeholder').empty();
          $('.js-completion-profil')
            .clone()
            .appendTo('#js-completion-profil-placeholder');

          // Rendering des pies de completion du profil
          pieCompletion.render(
            $('.js-pie-completion-profil').attr('data-value'),
            '.js-pie-completion-profil',
            '#26aae1',
            '#5adfb7'
          );

          // mise a jour du toaster de creation d'alerte avec les nouveaux criteres de recherche
          if (data.configurationCreationAlerte) {
            window.toasterCreationAlerteListe = new ToasterCreationAlerte(
              data.configurationCreationAlerte
            );

            if (hasCriteres) {
              $('.js-creer-alerte').removeClass('hidden');
            } else {
              $('.js-creer-alerte').addClass('hidden');
            }
          } else {
            // on cache le toaster et le lien pour creer une alerte mail (recherche sans filtre)
            if (!!window.toasterCreationAlerteListe) {
              window.toasterCreationAlerteListe.resetState();
            }
            window.toasterCreationAlerteListe = null;
            $('.js-btn-creer-alerte').addClass('hidden');
          }

          modifiePubNative(offreSponsoId, {
            fonction: model.fonctions.map(f => f.code.toString()),
            region:
              model.localisation && model.localisation.type === SUGGESTION_REGION
                ? [model.localisation.region.code.toString()]
                : []
          });
        },
        error: function(data) {
          moteurLoaderSearch.hide(0);
          $('.js-liste-offre').before(
            '<p id="message" class="alert-box error">' +
              '<span class="icon-warning"></span>' +
              $.parseJSON(data.responseText).errors[0] +
              '<a href="" class="close" title="fermer">x</a>' +
              '</p>'
          );
        }
      });
    }, 100);
  }

  function loadLocalisations(query) {
    $.ajax({
      type: 'GET',
      url:
        `${globalScope.domainUrlServices}/services/suggestions/v1/locations/` +
        encodeURIComponent(query),
      dataType: 'json',
      success: function(data) {
        // On cache elargirRechercheSelector
        elargirRechercheContainer.hide();
        elargirRechercheContainer.removeClass('actif');

        localisationOptions.localisationSelector({
          onItemsSelected: function(selectedItems) {
            model.localisation = selectedItems;
            model.regions = []
            model.departements = []

            ga.deprecatedSendEvent(
              'temporaire',
              'change_recherche',
              'change_localisation' + model.localisation.type
            );

            // Affiche le bouton �largir recherche si page de liste et d�partement/ville s�lectionn�
            if (
              configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE &&
              (model.localisation.type === SUGGESTION_DEPARTEMENT ||
                model.localisation.type === SUGGESTION_VILLE)
            ) {
              elargirRechercheContainer.show();
            } else {
              elargirRechercheContainer.hide();
            }

            localisationOptions.removeClass('toggled');
            modelUpdated();
            load();
          },
          availableItems: data,
          selectedItems: model.localisation
        });

        localisationOptions.addClass('toggled');
      }
    });
  }

  function loadDepartementsVoisins() {
    $.ajax({
      type: 'GET',
      url:
        `${globalScope.domainUrlServices}/services/suggestions/v1/neighborDepartments/` +
        model.localisation.department.code,
      contentType: 'application/json',
      success: function(data) {
        elargirRechercheSelector.elargirRechercheSelector({
          onItemsSelected: function(selectedItems) {
            $('.js-apply-elargir-recherche').click(function() {
              model.localisation.neighborDepartments = selectedItems;

              ga.deprecatedSendEvent(
                'temporaire',
                'change_recherche',
                'elargit_localisationdepartement'
              );

              // Ferme le bloc d�roulant � la selection
              elargirRechercheSelector.removeClass('toggled');

              // Active/d�sactive le bouton
              if (selectedItems.length > 0) elargirRechercheContainer.addClass('actif');
              else elargirRechercheContainer.removeClass('actif');

              modelUpdated();
              load();
            });
          },
          availableItems: data,
          selectedItems: model.localisation.neighborDepartments,
          type: model.localisation.type
        });

        elargirRechercheSelector.addClass('toggled');
      }
    });
  }

  function loadDistanceKilometrique() {
    elargirRechercheSelector.elargirRechercheSelector({
      onItemsSelected: function(selectedItems) {
        $('.js-apply-elargir-recherche').click(function() {
          model.localisation.distanceInKm = selectedItems[0];

          ga.deprecatedSendEvent('temporaire', 'change_recherche', 'elargit_localisationville');

          // Ferme le bloc d�roulant � la selection
          elargirRechercheSelector.removeClass('toggled');

          modelUpdated();
          load();
        });
      },
      availableItems: DISTANCES_KILOMETRIQUES,
      selectedItems: [model.localisation.distanceInKm],
      type: model.localisation.type
    });

    elargirRechercheSelector.addClass('toggled');
  }

  // Display du menu de selection par click
  function initialiseSelectors() {
    if (model.regions != null && model.regions.length > 0) {
      model.localisation = {
        type: SUGGESTION_REGION,
        region: model.regions[0]
      };
    } else if (model.departements != null && model.departements.length > 0) {
      model.localisation = {
        type: SUGGESTION_DEPARTEMENT,
        department: model.departements[0]
      };
      if (model.departements.length > 1) {
        model.localisation.neighborDepartments = model.departements.slice(1);
      }
    }

    if (!!model.localisation) {
      switch (model.localisation.type) {
        case SUGGESTION_VILLE:
          localisationTrigger.val(model.localisation.city);
          elargirRechercheContainer.show();
          break;
        case SUGGESTION_DEPARTEMENT:
          localisationTrigger.val(
            model.localisation.department.label + ' (' + model.localisation.department.code + ')'
          );

          if (model.localisation.neighborDepartments != null && model.localisation.neighborDepartments.length > 0) {
            elargirRechercheContainer.addClass('actif');
          } else {
            elargirRechercheContainer.removeClass('actif');
          }

          elargirRechercheContainer.show();
          break;
        case SUGGESTION_REGION:
          localisationTrigger.val(model.localisation.region.label);
          elargirRechercheContainer.hide();
          break;
        default:
          localisationTrigger.val(model.localisation.keyword);
          elargirRechercheContainer.hide();
          break;
      }
    }

    $('.js-elargir-recherche').click(function(e) {
      e.stopPropagation();
      closeAutresCriteres(e);

      if (model.localisation.type === SUGGESTION_DEPARTEMENT) {
        loadDepartementsVoisins();
      } else if (model.localisation.type === SUGGESTION_VILLE) {
        loadDistanceKilometrique();
      }
    });

    localisationTrigger.keyup(e => {
      e.stopPropagation();
      const doitGererSuggestions =
        localisationOptions.hasClass('toggled') && $('.js-localisations-displayer').is(':visible');
      const locSuggArray = $('.js-suggestion-label').toArray();

      switch (e.key) {
        case 'Enter':
          const selectedSuggestion = $('.js-suggestion-label.selected, .js-suggestion-label:hover');
          doitGererSuggestions && selectedSuggestion.length > 0
            ? selectedSuggestion.first().click()
            : $('.js-moteur-top-submit').click();
          break;
        case 'ArrowUp':
          if (doitGererSuggestions) {
            const indexSelected = locSuggArray.findIndex(e => e.classList.contains('selected'));
            const newSelected =
              locSuggArray[indexSelected - 1] || locSuggArray[locSuggArray.length - 1];

            if (indexSelected !== -1) locSuggArray[indexSelected].classList.remove('selected');
            newSelected.classList.add('selected');
          }
          break;
        case 'ArrowDown':
          if (doitGererSuggestions) {
            const indexSelected = locSuggArray.findIndex(e => e.classList.contains('selected'));
            const newSelected = locSuggArray[indexSelected + 1] || locSuggArray[0];

            if (indexSelected !== -1) locSuggArray[indexSelected].classList.remove('selected');
            newSelected.classList.add('selected');
          }
          break;
        default:
          elargirRechercheContainer.hide();
          model.localisation = null;

          window.clearTimeout(loadTimeOutLocalisationSelector);
          loadTimeOutLocalisationSelector = window.setTimeout(() => {
            var query = localisationTrigger.val().trim();
            if (query === '') {
              localisationOptions.removeClass('toggled');
            } else {
              loadLocalisations(query);
            }
          }, 300);
      }
    });

    $('.js-critere').click(function(e) {
      e.stopPropagation(); // Empeche le callback d'etre effectue deux fois lorsqu'on clique sur la fleche

      const elem = $(this)
        .parents()
        .toArray()
        .find(parent => parent.className.indexOf('liste-criteres') !== -1);

      listeCriteres.not(elem).removeClass('toggled');
      $(elem).toggleClass('toggled');
    });

    // On cache les onglets quand on clique en dehors
    $(document).click(function(e) {
      closeAutresCriteres(e);
    });

    function closeAutresCriteres(e) {
      const elem = $(e.target);
      let outside = true;

      elem
        .parents()
        .toArray()
        .forEach(parent => {
          if (parent.classList.contains('js-liste-criteres')) {
            outside = false;
          }
        });

      if (outside) {
        listeCriteres
          .removeClass('toggled')
          .find('.multi-selector-item')
          .removeClass('toggled');
      }
      toggleRappelCriteresMotsCles();
    }
  }

  function toggleRappelCriteresMotsCles() {
    const rappelLoc = rappelCriteresMotsCles.children('.js-rappel-criteres-loc');
    const hasRappelCriteres =
      rappelCriteresMotsCles
        .children('.js-rappel-criteres')
        .text()
        .trim() ||
      (rappelLoc.text().trim() && rappelLoc.is(':visible')); // is visible pour g�rer le display none en non mobile

    if (hasRappelCriteres && !monochampsRecherche.is(':focus')) {
      rappelCriteresMotsCles.removeClass('hidden');
    } else {
      rappelCriteresMotsCles.addClass('hidden');
    }
  }

  // On modifie le style de l'element si une valeur lui est attribu�e
  function setNotEmptyClass(elem) {
    if (elem.val() !== '') {
      elem.addClass('not-empty');
    } else {
      elem.removeClass('not-empty');
    }
  }

  // La modal ne  s'ouvre qu'en version mobile
  function openModal() {
    $('.bubble-closed-alerte.js-open-toaster-creation-alerte').addClass('hidden');
    moteurTopListe.addClass('moteur-modal');
    $('body').addClass('no-scroll');
    $('.js-fonctions-moteur-liste').addClass('fonctions-old-tab');
    $('.js-secteurs-moteur-liste').addClass('secteurs-old-tab');
  }

  function closeModal() {
    $('.bubble-closed-alerte.js-open-toaster-creation-alerte').removeClass('hidden');
    moteurTopListe.removeClass('moteur-modal');
    $('body').removeClass('no-scroll');
    $('.js-fonctions-moteur-liste').removeClass('fonctions-old-tab');
    $('.js-secteurs-moteur-liste').removeClass('secteurs-old-tab');
  }

  //LISTE
  function memoriseRecherche(model) {
    function serializeParams(parameters) {
      const results = Array();

      $.each(parameters, function(key, value) {
        if (typeof value === 'object' || Array.isArray(value)) {
          $.each(value, function(subkey, subvalue) {
            const strValueEncoded = subvalue.toString().replace(/\s+/g, '+');
            results.push(key + '=' + strValueEncoded);
          });
        } else if (value) {
          // !== null/undefined
          const strValueEncoded = value.toString().replace(/\s+/g, '+');
          results.push(key + '=' + strValueEncoded);
        }
      });

      return results.join('&');
    }

    const parameters = buildParameters(model);

    $.ajax({
      type: 'POST',
      url: '/emploi/liste_offres/rechercher',
      data: serializeParams(parameters),
      contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
      success: function() {
        const cookie = Cookies.get('recherches_memorisees');
        // NB : cookie en json encod� via URLEncoder.encode() dans RechercheMemoriseeCookieHelper.kt
        // mais lors du decode ci-dessous, decodeURIComponent ne remplace pas les + en espaces (cf. doc), on le fait manuellement avec un replace
        const recherches = !!cookie ? JSON.parse(decodeURIComponent(cookie.replace(/\+/g, ' '))) : [];

        const blocRecherchesMemorisees = $('#liste-recherches-memorisees');
        blocRecherchesMemorisees.empty();

        $.each(recherches, function(index, recherche) {
          const fieldItem = $(
            '<li class="list-item">' +
              '   <a title="lancer la recherche" class="lancer-recherche js-lancer-recherche-memorisee" href="' +
              encodeURI(recherche.lienRecherche) +
              '">' +
              '       <span class="recherche-localisation">' +
              '           <span class="recherche">' +
              recherche.labelRecherche +
              '</span>' +
              '           <span class="localisation">' +
              recherche.labelLocalisation +
              '</span>' +
              '       </span>' +
              '    </a>' +
              '</li>'
          );

          blocRecherchesMemorisees.prepend(fieldItem);
        });
      }
    });
  }

  //LISTE
  function makeSmallString(array, max) {
    const labels = array.map(elem => elem.label);
    if (labels.length > max) {
      return labels.slice(0, max).join(', ') + ' +' + (labels.length - max);
    } else {
      return labels.join(', ');
    }
  }

  //LISTE
  function updateRappelCriteres() {
    const rappelCriteres = [];
    if (model.motsCles) {
      rappelCriteres.push(model.motsCles);
    }
    if (model.fonctions.length > 0) {
      rappelCriteres.push(makeSmallString(model.fonctions, 1));
    }
    if (model.contrats.length > 0) {
      rappelCriteres.push(makeSmallString(model.contrats, 2));
    }
    if (model.secteurs.length > 0) {
      rappelCriteres.push(makeSmallString(model.secteurs, 1));
    }
    if (model.salaireMin > 0) {
      rappelCriteres.push(Math.round(model.salaireMin / 1000) + ' K&euro;');
    }

    // On ne peut pas ajouter la loc dans l'array car on ne veut l'afficher que si on est en mobile (g�r� en css)
    let critereLocalisation = '';
    if (model.localisation) {
      switch (model.localisation.type) {
        case SUGGESTION_VILLE:
          critereLocalisation = model.localisation.city;
          break;
        case SUGGESTION_DEPARTEMENT:
          critereLocalisation = `${model.localisation.department.label} (${
            model.localisation.department.code
          })`;
          break;
        case SUGGESTION_REGION:
          critereLocalisation = model.localisation.region.label;
          break;
        default:
          critereLocalisation = model.localisation.keyword || '';
          break;
      }
    } else if ((model.regions != null && model.regions.length > 0) ||
      (model.departements != null && model.departements.length > 0)) {
      critereLocalisation = 'multi-localisations'
    }

    $('.js-rappel-criteres').html(rappelCriteres.join('&nbsp;&bull;&nbsp;'));
    // Il faut ajouter la puce seulement si il y a d'autres criteres avant
    let puceLoc = critereLocalisation !== '' && rappelCriteres.length > 0 ? '&nbsp;&bull;' : '';
    $('.js-rappel-criteres-loc').html(`${puceLoc} ${critereLocalisation}`);
  }

  function buildParameters(model) {
    const parameters = {};
    const locQuery = localisationTrigger.val().trim();

    if (model.fonctions && model.fonctions.length > 0) {
      parameters.selectedFonctions = model.fonctions.map(fonction => fonction.code);
    }
    if (model.secteurs && model.secteurs.length > 0) {
      parameters.selectedSecteurs = model.secteurs.map(secteur => secteur.code);
    }
    if (model.localisation) {
      if (model.localisation.keyword && model.localisation.keyword !== '') {
        parameters.selectedLocalisationLibre = model.localisation.keyword;
      }
      if (model.localisation.city) {
        parameters.selectedVilleLibelle = model.localisation.city;
        if (model.localisation.slug) {
          parameters.selectedVilleSlug = model.localisation.slug
        }
      }
      if (model.localisation.geoCode) {
        parameters.selectedVilleLat = model.localisation.geoCode.latitude;
        parameters.selectedVilleLon = model.localisation.geoCode.longitude;
      }
      if (model.localisation.department)
        parameters.selectedDepartementCode = model.localisation.department.code;
      if (model.localisation.region)
        parameters.selectedRegionIsoCode = model.localisation.region.isoCode;
      parameters.selectedLocalisationType = model.localisation.type;
      parameters.selectedRegions = []
      parameters.selectedDepartements = []
    } else if (locQuery !== '') {
      parameters.selectedLocalisationLibre = locQuery;
      parameters.selectedLocalisationType = 'libre';
      parameters.selectedRegions = []
      parameters.selectedDepartements = []
    } else {
      if (model.regions != null && model.regions.length > 0) {
        parameters.selectedRegions = model.regions.map(region => region.code);
      }
      if (model.departements != null && model.departements.length > 0) {
        parameters.selectedDepartements = model.departements.map(departement => departement.code);
      }
    }
    if (model.contrats && model.contrats.length > 0) {
      parameters.codesContrats = model.contrats.map(contrat => contrat.code);
    }
    if (model.salaireMin > 0) {
      parameters.salaireMin = model.salaireMin;
    }
    if (model.motsCles || motsClesTop.val()) {
      parameters.motsCles = model.motsCles ? model.motsCles : motsClesTop.val();
    }

    return parameters;
  }

  function buildTrackingCriteres(model) {
    const tracking = [];
    const locQuery = localisationTrigger.val().trim();

    if (model.secteurs && model.secteurs.length > 0) {
      tracking.push('secteur');
    }
    if (model.fonctions && model.fonctions.length > 0) {
      tracking.push('fonction');
    }
    if (model.localisation || locQuery !== '') {
      tracking.push('localisation' + (model.localisation ? model.localisation.type : 'libre'));
    }
    if (model.contrats && model.contrats.length > 0) {
      tracking.push('contrat');
    }
    if (model.salaireMin > 0) {
      tracking.push('salairemin');
    }
    if (model.motsCles || motsClesTop.val()) {
      tracking.push('motcle');
    }

    return tracking;
  }

  if (configuration.moteurRechercheConfiguration.page === PAGE_LISTE_OFFRE) {
    //LISTE
    $(document).on(
      'scroll',
      throttle(200, () => {
        if (window.scrollY > 200) {
          if (hasCriteres) {
            rappelCriteresScrollActivation.addClass('active');
          } else {
            rappelCriteresScrollActivation.addClass('active-mobile');
          }
        } else {
          rappelCriteresScrollActivation.removeClass('active');
          rappelCriteresScrollActivation.removeClass('active-mobile');
        }
      })
    );

    // Le binding reste actif meme apres un rechargement de la liste
    $(document).on('click', '.js-lien-pagination', function(e) {
      if (useAjax) {
        e.preventDefault();

        model.page = parseInt(this.innerText);
        load();
      }
    });

    //LISTE
    $(document).on('change', '.js-tri', function() {
      model.tri = $('.js-tri')
        .find(':selected')
        .val();
      modelUpdated();
      load();
    });

    //LISTE
    $(document).on('click', '.js-lien-pagination-prev', function(e) {
      if (useAjax) {
        e.preventDefault();

        model.page--;
        load();
      }
    });

    //LISTE
    $(document).on('click', '.js-lien-pagination-next', function(e) {
      if (useAjax) {
        e.preventDefault();

        model.page++;
        load();
      }
    });
    //LISTE
    $(document).on('click', '.lien-page.pointsDerriere', function(e) {
      if (useAjax) {
        e.preventDefault();

        model.page = 1;
        load();
      }
    });

    //LISTE
    $(document).on('click', '.lien-page.pointsDevant', function(e) {
      if (useAjax) {
        e.preventDefault();

        model.page = parseInt(this.innerText);
        load();
      }
    });
    //LISTE
    modelUpdated();

    //LISTE
    $('.js-cta-search-desktop .js-moteur-top-submit').click(function(e) {
      e.preventDefault();
      const locQuery = localisationTrigger.val().trim();
      if (!model.localisation && locQuery !== '') {
        model.localisation = {
          keyword: locQuery,
          type: 'libre'
        };
      }
      memoriseRecherche(model);
      modelUpdated();
      load();
    });

    //LISTE
    $('.js-cta-search-mobile .js-moteur-top-submit').click(function(e) {
      e.preventDefault();
      closeModal();
    });
  }
}

// Tracking de l'affichage des boutons de candidature rapide/1clic et des labels
const trackApplyButtonsDisplay = function(isUserConnected) {
  function formatLabel(typeCandidature, label) {
    let formated = label.length > 0
      ? label
          .html()
          .toLowerCase()
          .replace(/ /g, '_')
      : 'sans_label'
    return `${typeCandidature}.${formated}`;
  }

  // initialisation d'un compteur vide
  let counter = {};
  // Parcours de tous les titres de la page de r�sultat
  $('.offre-card > .js-lien-detail-offre:first-child').each((key, value) => {
    let offreId = value.getAttribute('data-value');
    let labelMiseEnAvant = $('#js-label-mea-' + offreId);
    let typeCandidature = value.getAttribute('data-type-candidature');
    let entry = formatLabel(typeCandidature, labelMiseEnAvant);
    counter[entry] > 0 ? counter[entry] += 1 : counter[entry] = 1 // creation/incr�ment du compteur
  });
  // Parcours de tous les �l�ments du compteur pour l'envoi des events GA
  Object.keys(counter).forEach(value => {
    if (counter[value] > 0) {
      let isFormulaire = value.split('.')[0] === 'formulaire';
      let label = value.split('.')[1];
      let action = isFormulaire ?
        isUserConnected ? 'affichage_liste_cta_postuler_1clic' : 'affichage_liste_cta_postuler_rapidement'
        : 'affichage_liste_postuler_asp';
      ga.sendNonInteractiveEvent(
        'navigation',
        action,
        label,
        counter[value]
      );
    }
  });
};

export { moteur_top, trackApplyButtonsDisplay };
